export default "__VITE_ASSET__CCQs9t_i__"